module.exports = __webpack_public_path__ + "static/media/vue.986e6311.png";